module.exports = __webpack_public_path__ + "img/side-arch-low.fb9e0e26.svg";